<script>
export default {
    data() {
        return {
            isBusy: false,
            success: false,
            errors: [],
            formElement: null,
        };
    },

    props: {
        successMessage: {
            type: String,
            default: "Enquiry sent.",
        },
    },

    computed: {},

    watch: {},

    methods: {
        onSubmit: function (e) {
            e.preventDefault();

            var formData = {};

            for (var i = 0; i < e.target.elements.length; ++i) {
                var element = e.target.elements[i],
                    name = element.name,
                    value = element.value;
                switch (element.type) {
                    case "radio":
                        {
                            if (name && element.checked) {
                                formData[name] = value;
                            }
                        }
                        break;
                    default: {
                        if (name) {
                            formData[name] = value;
                        }
                    }
                }
            }

            this.sendFormData(formData);
        },

        sendFormData: function (formData) {
            var self = this;

            self.isBusy = true;
            self.errors = [];

            self.$http
                .post(self.formElement.action, formData, {
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                })
                .then(
                    (response) => {
                        // console.log(response.body);

                        if (
                            typeof response.body.success !== "undefined" &&
                            response.body.success === true
                        ) {
                            self.success = true;
                        } else if (
                            typeof response.body.errors !== "undefined"
                        ) {
                            self.success = false;
                            self.errors = response.body.errors;
                        }

                        self.isBusy = false;
                    },
                    (response) => {
                        self.success = false;

                        if (typeof response.body.errors === "undefined") {
                            self.errors = [
                                "An error occured sending the form. Please check the fields and try again, or contact us.",
                            ];
                        } else {
                            self.errors = response.body.errors;
                        }

                        self.isBusy = false;
                    }
                );
        },
    },

    components: {},

    created() {},
    mounted() {
        var self = this;
        self.formElement = document.querySelector(".form-wrapper form");
        self.formElement.addEventListener("submit", self.onSubmit);
    },
};
</script>

<style></style>

<template>
    <div
        class="form-wrapper"
        :class="{
            'form-wrapper--busy': isBusy,
            'form-wrapper--success': success,
        }"
    >
        <transition name="fade-slow" mode="out-in">
            <div class="form-wrapper__body" v-if="success" key="hide">
                <p class="form-wrapper__success">{{ successMessage }}</p>
            </div>

            <div class="form-wrapper__body" v-else key="show">
                <ul class="form-wrapper__errors" v-if="errors && errors.length">
                    <li v-for="(errorMessage, index) in errors" :key="index">
                        {{ errorMessage }}
                    </li>
                </ul>

                <slot name="form-body"></slot>
            </div>
        </transition>
    </div>
</template>
